export default __webpack_public_path__ + "static/Framework-fa01dcb1d3b64afbd594facaee0ab0ca.svg";